import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'
import AnalyticData from './analytic-data'
import selectTabs from '../../../components/select-tabs/select-tabs.vue'
import Serpbook from '../../../components/serpbook/serpbook.vue'
import verticalBlocks from '../../../components/blocks/vertical-block.vue'
import horizontalBlocks from '../../../components/blocks/horizontal-block.vue'
import { lineChart, doughnutChart } from '../../../components/charts/index'
import { lineChartData, lineChartOptions, doughnutChartData, doughnutChartOptions } from './chartConfig'
import { ISession, IChartData } from '../../../types'
import { CancelTokenStatic, CancelTokenSource } from 'axios'

@Component({
  components: {
    verticalBlocks,
    horizontalBlocks,
    selectTabs,
    lineChart,
    doughnutChart,
    Serpbook,
  },
  computed: mapState({
    Authenticated: (state: {session: ISession}) => state.session.UserId ? true : false,
    Moderator: (state: {session: ISession}) => state.session.roles != undefined ? true : false,
    Service: (state: {session: ISession}) => state.session.service,
    ServiceId: (state: {session: ISession}) => state.session.serviceId,
  })
})

export default class Overview extends Vue {

  private namespace: string = '/GeneralReport';

  private endpoints: string[] = ['/ReportHeaders', '/Devices', '/Genders', '/Sessions-Chart', '/Pie-Chart']; // '/TopKeywords

  private cancelToken?: CancelTokenStatic;

  private source?: CancelTokenSource;

  private Authenticated!: boolean;

  private Moderator!: boolean;

  private Service!: string;

  private ServiceId!: number;

  private length: number = 7;

  private availableDataLengths: number = 0;

  private chart: number = 1;

  private report: string = 'weeklyReport';

  private analytics: Partial<AnalyticData> = AnalyticData.getState();

  private alertMessage: string = '';

  private get availableLengths () {

    const lengths = [
      `7 ${ this.$tc('shared.days', 2) }`,
      `30 ${ this.$tc('shared.days', 2) }`,
      `365 ${ this.$tc('shared.days', 2) }`
    ];

    return lengths.slice(0, this.availableDataLengths === 365 ? 3 : this.availableDataLengths === 30 ? 2 : 1);
  }

  private get PieTabs () {

    const tabs = [
      {
        title: this.$t('overview.analytics.grouping'),
        icon: 'mdi-format-list-bulleted-type',
        enabled: false,
      },
      {
        title: this.$t('overview.analytics.city'),
        icon: 'mdi-city',
        enabled: false,
      },
      {
        title: this.$t('overview.analytics.age'),
        icon: 'mdi-human-handsup',
        enabled: false,
      }
    ];

    if (this.analytics[this.report].pieChart != undefined) {
      
      this.analytics[this.report].pieChart.data.forEach((tab: IChartData, i: number) => {
        
        tabs[i].enabled = tab.data.length > 0;

        if (!tabs[i].enabled && this.chart === i) {

          this.chart = tabs.indexOf(tabs.find(item => item.enabled) as {title: string, icon: string, enabled: boolean});
        }
      });

      return tabs;
    }

    return tabs 
  }

  private get SessionChartData () {

    const chart = this.analytics[this.report].sessionsChart;

    if (chart != null && chart.status == 200) {

      let chartData = {...lineChartData};

      chartData.labels = chart.data.dashLabels;
      chartData.datasets.map((set: {label: string, data: number[]}) => {

        set.label = this.$t('overview.analytics.totalSessions') as string;
        set.data = chart.data.data;
      })
      
      return chartData;
    }

    return lineChartData;
  }

  private get SessionChartOptions () {
    // Leaving this. For formating lines on Y axis

    if (this.analytics[this.report].sessionsChart != null && this.analytics[this.report].sessionsChart.status === 200) {
      
      // const options = this.analytics[this.report].sessionsChart.data,
      //       maxNum =  options.data.map((val: number) => Math.max.apply(null, options.data))[0],
      //       minNum = options.data.map((val: number) => Math.min.apply(null, options.data))[0];

      let chartOptions = {...lineChartOptions};

      // chartOptions.scales.yAxes[0].ticks.max = maxNum;

      // chartOptions.scales.yAxes[0].ticks.min = minNum;

      // chartOptions.scales.yAxes[0].ticks.stepSize = 26;

      chartOptions.scales.xAxes[0].ticks.callback = (value: string, index: number, values: string[]) => value.split(' ')[0];

      return chartOptions;
    }
    
    return lineChartOptions;
  }

  private get PieChartData () {

    const charts = this.analytics[this.report].pieChart;

    if (charts != null && charts.status === 200) {

      let chartData = {...doughnutChartData};
      
      chartData.labels = charts.data[this.chart].labels;
      chartData.datasets[0].data = charts.data[this.chart].data;

      return chartData;
    }

    return doughnutChartData;
  }

  private get PieChartOptions () {
    
    return doughnutChartOptions;
  }

  mounted () {
    
    this.cancelToken = this.$axios.CancelToken;
    this.source = this.cancelToken.source();
    
    if (this.Authenticated && this.ServiceId) {

      this.getReports(['/MaxLength']).then(() => this.getReports(this.endpoints));
    }

    if (this.Moderator && this.Service == undefined) {
  
      return this.alertMessage = 'Please select service';
    }
  }

  private getReports (endpoints: string[]) {
    return new Promise((resolve) => {
    endpoints.forEach((endpoint, index) => {

      const property: string = endpoint.charAt(1).toLowerCase() + endpoint.substring(2).replace(/\/|-/g, '');
      
      this.$axios.get(`${this.$apiUrl + this.namespace + endpoint}`, {
        cancelToken: typeof(this.source) !== 'undefined' ? this.source.token : undefined,
        params: {
          length: this.length,
          serviceId: this.ServiceId
        }
      })

      .then(response => {

        this.handleResponse({
          property,
          response: {
            status: response.status,
            data: response.data
          }
        });
      })

      .catch(error => {
        
        this.handleResponse({
          property,
          response: {
            status: 500,
            message: error.message
          }
        });
      })

      if (index + 1 == endpoints.length) {

        resolve(true);
      }
    })
  });
  }

  private handleResponse(data: {property: string, response: {status: number, data?: any, message?: any}}) {

    if ('maxLength' === data.property) {

      return this.availableDataLengths = data.response.data;
    }

    return this.$set(this.analytics[this.report], data.property, data.response);
  }

  private setChart(index: number) {

    this.chart = index;
  }

  private setReport (report: {type: string, index: number, length: number}) {

    const allowedReports = ['weeklyReport', 'monthlyReport', 'yearlyReport'];
    
    if ('analytics' === report.type) {

      const prevReport = this.report;
      
      this.length = report.length;
      this.report = allowedReports[report.index];

      if (Object.keys(this.analytics[prevReport]).length < this.endpoints.length) {
        
        if (this.source != undefined && this.cancelToken != undefined) {
         
          // Cancel prev requests if all not resolved.
          this.source.cancel();
          this.source = this.cancelToken.source();
          AnalyticData.flushState(prevReport);
        }
      }

      if (Object.keys(this.analytics[this.report]).length === 0) {

        this.getReports(this.endpoints)
      }
    }
  }

  @Watch('ServiceId')
  private updateReports (next: number, prev: number | undefined) {

    if (next != null && next != prev) {

      AnalyticData.flushState();
      this.alertMessage = '';
      this.availableDataLengths = 0;
      this.getReports(['/MaxLength']).then(() => this.getReports(this.endpoints));
    }
  }
}